import { NgModule } from "@angular/core";
import { GridModule } from "@progress/kendo-angular-grid";
import { InputsModule } from "@progress/kendo-angular-inputs";
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { LabelModule } from "@progress/kendo-angular-label"
import { IconsModule } from "@progress/kendo-angular-icons";
import { DropDownsModule, MultiSelectModule } from "@progress/kendo-angular-dropdowns";
import { DialogModule, DialogsModule } from "@progress/kendo-angular-dialog";
import { UploadsModule } from "@progress/kendo-angular-upload";
import { TooltipModule, TooltipsModule } from "@progress/kendo-angular-tooltip";
import { DateInputsModule } from "@progress/kendo-angular-dateinputs";
import { ChartsModule } from '@progress/kendo-angular-charts';
import { BadgeModule,  } from '@progress/kendo-angular-indicators';

import { IndicatorsModule, LoaderModule } from '@progress/kendo-angular-indicators';
import { ExpansionPanelModule, LayoutModule } from "@progress/kendo-angular-layout";
import { KENDO_PDFEXPORT, PDFExportModule } from "@progress/kendo-angular-pdf-export";
import { TabStripModule } from "@progress/kendo-angular-layout";
import { EditorModule } from '@progress/kendo-angular-editor';
import { TextBoxModule } from '@progress/kendo-angular-inputs';
import { DragAndDropModule } from "@progress/kendo-angular-utils";
import { ScrollViewModule } from '@progress/kendo-angular-scrollview';
import { KENDO_LABEL } from "@progress/kendo-angular-label";
import { ProgressBarModule } from "@progress/kendo-angular-progressbar";




@NgModule({
    declarations: [],
    imports: [
        GridModule, 
        InputsModule,
        ButtonsModule,
        LabelModule,
        IconsModule,
        DropDownsModule,
        MultiSelectModule,
        TextBoxModule,
        UploadsModule,
        TooltipsModule,
        DateInputsModule,
        ChartsModule,
        LoaderModule,
        LayoutModule,
        PDFExportModule,
        ExpansionPanelModule,
        TabStripModule,
        BadgeModule,
        DialogModule,
        EditorModule,
        DragAndDropModule,
        ScrollViewModule,
        ProgressBarModule
    ],
    providers: [],
    exports: [
        GridModule, 
        InputsModule,
        ButtonsModule,
        LabelModule,
        IconsModule,
        DropDownsModule,
        MultiSelectModule,
        TextBoxModule,
        UploadsModule,
        DialogsModule,
        TooltipsModule,
        DateInputsModule,
        ChartsModule,
        LoaderModule,
        LayoutModule,
        PDFExportModule,
        ExpansionPanelModule,
        TabStripModule,
        BadgeModule,
        DialogModule,
        TooltipModule,
        EditorModule,
        DragAndDropModule,
        ScrollViewModule,
        ProgressBarModule
    ]
})
export class KendoPackageModule { }